.primary {
  color: #59d;
}

.success {
  color: #6c6;
}

.info {
  color: #5bd;
}

.warning {
  color: #d93;
}

.danger {
  color: #d55;
  border-color: #d43f3a;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkRyb3Bkb3duTWVudS5zYXNzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7OztBQUNGO0VBQ0U7OztBQUNGO0VBQ0U7OztBQUNGO0VBQ0U7OztBQUNGO0VBQ0U7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi5wcmltYXJ5XG4gIGNvbG9yOiAjNTlkXG4uc3VjY2Vzc1xuICBjb2xvcjogIzZjNlxuLmluZm9cbiAgY29sb3I6ICM1YmRcbi53YXJuaW5nXG4gIGNvbG9yOiAjZDkzXG4uZGFuZ2VyXG4gIGNvbG9yOiAjZDU1XG4gIGJvcmRlci1jb2xvcjogI2Q0M2YzYVxuIl19 */